
<div>
  <article class="py-8">
    <h2 class="mb-4 md:mb-8 text-lg lg:text-xl">
      Related Collection Objects
    </h2>
    <LoadingSpinner
      v-if="isLoading"
      data-testid="relations-loading-message"
      class="text-xsoke w-18"
    />
    <div v-if="error" role="alert">
      <h3 class="text-lg lg:text-xl">{{ error }}</h3>
    </div>
    <CollectionObjectsTagsSearch
      v-if="tags"
      :tags="tags.objectRecordTags"
      :object-record-id="objectRecordId"
      data-testid="related-objects-section"
    />
  </article>
</div>
